import { isArray } from "lodash";
import { getUserDetails } from "../../helpers";


const user = getUserDetails();
const userRoles = user?.rolesAssigned;
export const checkEligibilityForAccess = (eligibleRoleArray) => {

    console.log(userRoles, "check role.");
    const indvArray = [];
    const allIndivRoleArray = getIndividualElementArray(eligibleRoleArray, indvArray);
    console.log(allIndivRoleArray, "Returned value");
    let checkResult = false;
    for (let i = 0; i < userRoles?.length; i++) {
        if (allIndivRoleArray.includes(userRoles[i])) {
            checkResult = true;
        }
    }
    console.log(checkResult, "check role result");
    return checkResult;
};

// [1100, 1101, 1102, [1104, 1106, 1109], 1110, [1201, 1203, 1204]]

export const getIndividualElementArray = (compoundElementArray, collectarray) => {

    if (isArray(compoundElementArray) && compoundElementArray.length > 0) {
        for (let i = 0; i < compoundElementArray.length; i++) {
            console.log(compoundElementArray, "compound array");
            getIndividualElementArray(compoundElementArray[i], collectarray);
        }

        return collectarray;
    } else {
        // not arrray
        collectarray.push(compoundElementArray);
        return compoundElementArray;
    }
};